import { Component, HostBinding, Input, OnInit, TemplateRef } from '@angular/core';
import { MuiIconFont } from '../icon';

@Component({
  selector: 'mui-label-value',
  template: `
    <div class="mui-lv__icon" *ngIf="icon">
      <i mui-icon [font]="iconFont" [name]="icon" class="fa-fw" color="default"></i>
    </div>
    <div class="mui-lv__text-wrapper">
      <div class="mui-lv__label" [id]="id + '-label'">
        {{ label }}
        <span
          *ngIf="popoverText"
          class="mui-label-value-popover"
          triggers="mouseenter:mouseleave touchstart"
          closeDelay="50"
          placement="bottom"
          [muiPopover]="popoverText">
          <i mui-icon font="fa" name="info-circle"></i>
        </span>
      </div>
      <div class="mui-lv__value" [class]="{ 'mui-text-color--secondary': !hasValue }" [attr.aria-describedby]="id + '-label'">
        <ng-container *ngIf="hasValue">
          <ng-container
            [ngTemplateOutlet]="customTemplate ? customTemplate : defaultValueTemplate"
            [ngTemplateOutletContext]="{ $implicit: value }"></ng-container>
        </ng-container>
        <ng-container *ngIf="!hasValue && ref?.childNodes.length < 1">
          {{ noValueAltText }}
        </ng-container>
        <span #ref class="mui-lv__value__ng-content"><ng-content></ng-content></span>
      </div>
    </div>
    <ng-template #defaultValueTemplate let-data>{{ data }}</ng-template>
  `
})
export class MuiLabelValue implements OnInit {
  @Input() value: any;
  /* Todo: Make this required once we migrate to Angular 16. */
  @Input() label!: string;
  @Input() icon?: string;
  @Input() iconFont: MuiIconFont | string = MuiIconFont.FONTAWESOME;
  @Input() customTemplate?: TemplateRef<any>;
  @Input() noValueAltText = 'n/a';
  @Input() popoverText?: string;

  @Input()
  @HostBinding('attr.id')
  id: string | null = null;

  @HostBinding('class.has--icon')
  get hasIcon(): boolean {
    return !!this.icon;
  }

  @HostBinding('class.mui-lv')
  readonly _muiBaseClass = true;

  get hasValue(): boolean {
    if (this.value && Object.prototype.hasOwnProperty.call(this.value, 'length')) {
      return this.value.length > 0;
    } else if (typeof this.value === 'number') {
      return true;
    } else {
      return !!this.value;
    }
  }

  ngOnInit(): void {
    if (this.label === undefined) {
      throw new Error('MuiOption: Required property label has not been set!');
    }
  }
}
